import { memo } from "react";

import { NAVIGATION_ICONS } from "./navigation-icons";
import type { INavigationIconProps } from "./types";

// NOTE: NSAI-6812 — draws a main-navigation entry's glyph by its shared key.
// Outside the sidebar the caller sets `--fill1` (or passes `stroke`), since
// the glyphs ink themselves with the sidebar's own variable.
const NavigationIconComponent = ({
  icon,
  ...props
}: INavigationIconProps): JSX.Element => {
  const Icon = NAVIGATION_ICONS[icon];

  return <Icon {...props} />;
};

export const NavigationIcon = memo(NavigationIconComponent);
